// Which realtime events reload a widget (see WidgetFrame); kept apart so it can be unit-tested.
import type { RealtimeEvent } from './client';

/**
 * Whether a realtime event should reload a widget. Syncs announce queued, started, progress and
 * finished; most widgets only need to reload when a sync changed data ("changes", the default),
 * status widgets when any sync finished ("completions"), the Sync page on every step ("all").
 * Events that aren't sync lifecycle events (orders arriving, config changes) always reload.
 */
export function reloadsOn(e: Pick<RealtimeEvent, 'event' | 'payload'>, lifecycle: 'changes' | 'completions' | 'all' = 'changes'): boolean {
  if (!e.event?.startsWith('sync.') || lifecycle === 'all') return true;
  const finished = e.event === 'sync.completed' || e.event === 'sync.failed' || e.event === 'sync.cancelled';
  if (!finished) return false;
  if (lifecycle === 'completions') return true;
  return e.event === 'sync.completed' && (Number(e.payload?.rowsProcessed ?? 0) > 0 || Number(e.payload?.rowsRepaired ?? 0) > 0);
}
